<template>
  <v-app>
    <v-app-bar
      app
      v-if="isLoggedIn"
      :style="'background-color: ' + appColour"
      class=""
      :dark="darkToolbar">
      <v-toolbar-title v-text="schoolName"/>
      <v-spacer/>
      <v-menu
        bottom
        left>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item>
            <v-list-item-title class="caption">Logged in as {{ parentName }}</v-list-item-title>
          </v-list-item>
          <v-divider/>

          <!-- <v-subheader v-if="sharedMultipleUsers.length !== 0">Switch School</v-subheader>

          <v-list-item-group
            color="primary"
          >
            <v-list-item
              v-for="(userdetails,id ) in sharedMultipleUsers"
              :key="id">
              <v-list-item-content @click="switchSchool(userdetails)">
                <v-list-item-title><b>{{ userdetails.schoolName }}</b></v-list-item-title>
                <v-list-item-subtitle>Login: {{ userdetails.pupilName }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider/>

          </v-list-item-group> -->
          <v-list-item
            @click="refresh()"
          >
            <v-list-item-title>Update
              <i class="fas fa-sync-alt"/>
            </v-list-item-title>
          </v-list-item>

          <v-list-item @click="$router.replace('/settings')">
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logoutDialog = !logoutDialog">
            <v-list-item-title>Log Out <v-icon color="black">launch</v-icon></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>

    <v-dialog
      v-model="logoutDialog"
      max-width="290">
      <v-card>
        <v-card-text class="text-center pb-0 pt-3">
          <v-icon
            size="50"
            color="red">warning</v-icon>
        </v-card-text>
        <v-card-text class="text-center subheading">Are you sure you want to log out?</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="error"
            text
            @click.native="logoutDialog = false">No</v-btn>
          <v-btn
            color="error"
            text
            @click.native="logoutDialog = false; logout()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loadingDialog"
      hide-overlay
      persistent
      fullscreen>
      <v-row
        class="fill-height"
        align="center"
        justify="center"

      >
        <v-card
          color="secondary"
          dark>
          <v-card-text>
            <v-progress-circular
              indeterminate
              color="white"
              class="mb-0"/>
          </v-card-text>
        </v-card>
      </v-row>
    </v-dialog>

    <v-content>
      <transition name="fade">
        <router-view/>
      </transition>
    </v-content>

    <!-- Update version snackbar -->
    <v-snackbar
      v-model="snackWithButtons"
      :timeout="timeout"
      bottom
      right
      class="snack">
      {{ snackWithBtnText }}
      <v-spacer />
      <v-btn
        dark
        text
        color="#00B0B9"
        @click.native="refreshApp">
        {{ snackBtnText }}
      </v-btn>
      <v-btn
        icon
        @click="snackWithButtons = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',

  data: () => ({
    logoutDialog: false,
    title: '@school',

    // Service Worker updating
    refreshing: false,
    registration: null,
    snackBtnText: '',
    snackWithBtnText: '',
    snackWithButtons: false,
    timeout: 0,
    sharedMultipleUsers: {}

  }),

  computed: {
    isLoggedIn: function () { return this.$store.getters.isLoggedIn },
    ...mapState(['parentName', 'schoolName', 'appColour', 'loadingDialog', 'appleSubscriptionToken', 'darkToolbar', 'userId', 'pupilId', 'dialog', 'currentDialogTitle'])
  },
  // components: {
  //   NewSchool
  // },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
      this.$router.replace('/login')
    },
    refresh: function () {
      this.$router.go()
    },
    showRefreshUI (e) {
      // Display a snackbar inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail
      this.snackBtnText = 'Refresh'
      this.snackWithBtnText = 'New content is available!'
      this.snackWithButtons = true
    },
    refreshApp () {
      this.snackWithButtons = false

      if (!this.registration || !this.registration.waiting) { return }
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    },

    tryParseJSON (jsonString) {
      try {
        var o = JSON.parse(jsonString)

        // Handle non-exception-throwing cases:
        // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
        // but... JSON.parse(null) returns null, and typeof null === "object",
        // so we must check for that, too. Thankfully, null is falsey, so this suffices:
        if (o && typeof o === 'object') {
          return o
        }
      } catch (e) { }

      return false
    },

    getSharedSchools () {
      this.$http.get('/school/' + this.$store.state.schoolId + '/sharedUsersTest/valid')
        .then(resp => {
          this.sharedMultipleUsers = resp.data.sharedUsers
        })
    },
    switchSchool: function (userdetails) {
      var obj = { mainUserId: this.$store.state.userId, school: this.$store.state.schoolId, anotherUserId: userdetails.shared_user_id }
      var sharedschooldata = JSON.stringify(obj)

      this.$http.post('/logInSharedUser', {
        'sharedUser': sharedschooldata
      })
        .then(resp => {
          if (typeof resp.data.error !== 'undefined') {

          } else {
            const data = {
              token: resp.data.token,
              userId: resp.data.parent_id,
              parentName: resp.data.parent_name,
              pupilId: resp.data.pupil_id,
              Dbasename: resp.data.dbasename,
              schoolId: resp.data.school_id,
              schoolName: resp.data.school_name,
              appColour: resp.data.app_colour,
              darkToolbar: resp.data.use_dark_toolbar,
              loginId: resp.data.new_user_id
            }

            this.$store.commit('logout')
            this.$store.dispatch('updateLoginState', data)
            this.$store.dispatch('checkUnreadCounts')
            this.$router.replace('/home')
            this.$router.go(0)
          }
        })
    }

  },

  mounted: function () {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('appColour ' + this.appColour)
      // Check sub token is up to date
      if (this.appleSubscriptionToken !== '') {
        window.ReactNativeWebView.postMessage('checkToken ' + this.appleSubscriptionToken)
      }
    }
  },

  created: function () {
    // Set page title to school name on load
    if (this.$store.state.schoolName !== null && this.$store.state.schoolName !== '') {
      document.title = this.$store.state.schoolName
    }

    // Closes dialog when back button is pressed
    window.onpopstate = () => {
      this.$store.commit('toggle_dialog', false)
    }

    // Check unread counts
    if (this.userId !== 0 && this.pupilId !== 0) {
      this.$store.dispatch('checkUnreadCounts')
      // this.getSharedSchools()
    }

    // Service Worker update code
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return
        this.refreshing = true
        window.location.reload()
      })
    }

    // ServiceWorker update badge on notification received by checking api
    if (navigator.serviceWorker) {
      navigator.serviceWorker.onmessage = (event) => {
        // console.log('event.data', event.data)
        if (event.data && event.data.type === 'update_unread') {
          // Check unread through api request
          this.$store.dispatch('checkUnreadCounts')

          // store.commit('increment_unread_badge', event.data.menuItem)
        }
      }
    }

    // Receiving messages from react native webview ios
    if (window.ReactNativeWebView) {
      window.addEventListener('message', (event) => { // Get apple subscription token
        let obj = this.tryParseJSON(event.data)
        if (obj === false && typeof event.data === 'string') {
          var messageArr = event.data.split(' ')
          var actionType = messageArr[0]

          if (actionType === 'appleSubscriptionToken' || actionType === 'unsubscribeAppleSubscriptionToken') {
            var isActive
            const subscriptionToken = event.data.split(' ')[1]

            if (typeof event.data === 'string') {
              if (event.data.split(' ')[0] === 'appleSubscriptionToken') {
                isActive = 1
                this.$store.commit('update_apple_subscription_token', subscriptionToken)
              } else if (event.data.split(' ')[0] === 'unsubscribeAppleSubscriptionToken') {
                isActive = 0
                this.$store.commit('update_apple_subscription_token', '')
              }
            }

            this.$http({
              method: 'post',
              url: 'https://www.atschool.co.nz/api/v2/registerPushSubscription',
              data: {
                subscription: JSON.stringify({
                  'appleToken': subscriptionToken
                }),
                is_active: isActive,
                caregiverId: this.$store.state.userId,
                schoolId: this.$store.state.schoolId
              }
            })
          } else if (actionType === 'updateAppleSubscriptionToken') {
            var newToken = messageArr[1]
            // Remove old token
            this.$http({
              method: 'post',
              url: 'https://www.atschool.co.nz/api/v2/registerPushSubscription',
              data: {
                subscription: JSON.stringify({
                  'appleToken': this.$store.state.appleSubscriptionToken
                }),
                is_active: 0,
                caregiverId: this.$store.state.userId,
                schoolId: this.$store.state.schoolId
              }
            })
            // Register new token
            this.$store.commit('update_apple_subscription_token', newToken)
            this.$http({
              method: 'post',
              url: 'https://www.atschool.co.nz/api/v2/registerPushSubscription',
              data: {
                subscription: JSON.stringify({
                  'appleToken': newToken
                }),
                is_active: 1,
                caregiverId: this.$store.state.userId,
                schoolId: this.$store.state.schoolId
              }
            })
          }
        } else if (typeof obj === 'object') {
          // console.log(obj.action)
          // console.log(obj.data)
          if (obj.action === 'appleNotificationReceived') {
            // Check unread through api request
            if (this.$store.state.token) {
              this.$store.dispatch('checkUnreadCounts')
            }
            // let temp = JSON.parse(obj.data)
            // store.commit('increment_unread_badge', temp)
          }
        }
      })
    }
  }
}
</script>

<style>
html,
body {
  overscroll-behavior-y: contain; /* Disables pull to refresh on android/chrome browsers */
}
.v-content {
  background-color: white;
}
.router-link-exact-active {
  background-color: lightgrey;
}
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .2s;
}
.fade-enter-active {
  transition-delay: .2s;
}
.fade-enter, .fade-leave-active {
  opacity: 0
}
.noscroll {
  position: fixed;
  overflow-x: hidden;
  overflow-y: hidden;
}

.v-dialog--fullscreen {
  -webkit-box-shadow: 0 0 0 0!important;
  box-shadow: 0 0 0 0!important;
}

/* Provide better right-edge spacing when using an icon button there. */
.snack >>> .v-snack__content {
  padding-right: 16px;
}

/* Set all text in v-cards to black, as it was grey before */
.theme--light.v-card > .v-card__text, .theme--light.v-card .v-card__subtitle {
    color: black;
}
</style>
